import { useRef, useState, useEffect, useCallback } from 'react'

export function useHorizontalScroll() {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const handleScroll = useCallback(() => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft
      const slideWidth = scrollContainerRef.current.offsetWidth
      const newSlide = Math.round(scrollLeft / slideWidth)
      if (newSlide !== currentSlide) {
        setCurrentSlide(newSlide)
      }
    }
  }, [currentSlide])

  const scrollToSlide = useCallback((index: number) => {
    if (scrollContainerRef.current) {
      const slideWidth = scrollContainerRef.current.offsetWidth
      scrollContainerRef.current.scrollTo({
        left: slideWidth * index,
        behavior: 'smooth',
      })
    }
  }, [])

  return {
    scrollContainerRef,
    currentSlide,
    isMobile,
    handleScroll,
    scrollToSlide,
  }
}
